import { useCountdown } from "@/hooks/useCountdown";
import { formatSessionDisplay } from "@/lib/selecao-sessions";
import { cn } from "@/lib/utils";

interface CountdownCardProps {
  target: Date;
  className?: string;
}

/**
 * Card sóbrio + compacto da próxima live. Estética institucional.
 */
export const CountdownCard = ({ target, className }: CountdownCardProps) => {
  const { days, hours, minutes, isPast } = useCountdown(target);
  const display = formatSessionDisplay(target);
  const pad = (n: number) => n.toString().padStart(2, "0");

  return (
    <div
      className={cn(
        "rounded-xl border border-zinc-200 bg-white",
        "px-4 py-3.5 sm:px-5 sm:py-4",
        className
      )}
      role="region"
      aria-label="Próxima live"
    >
      <div className="text-[10px] font-semibold tracking-[0.14em] uppercase text-zinc-500">
        Próxima live
      </div>

      <div className="mt-1.5 text-base sm:text-lg font-semibold text-[#112711] tracking-tight leading-snug">
        {display}
      </div>

      {!isPast ? (
        <div
          className="mt-2 text-xs sm:text-sm text-zinc-600 tabular-nums"
          aria-label={`Faltam ${days} dias, ${hours} horas e ${minutes} minutos`}
        >
          em <span className="font-semibold text-[#112711]">{pad(days)}d {pad(hours)}h {pad(minutes)}m</span>
        </div>
      ) : (
        <div className="mt-2 text-xs sm:text-sm text-zinc-600">Live em andamento</div>
      )}

      <div className="mt-3 pt-3 border-t border-zinc-100 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-zinc-500">
        <span>60 minutos</span>
        <span aria-hidden="true">·</span>
        <span>Entenda 100% como funciona</span>
        <span aria-hidden="true">·</span>
        <span>Sem replay</span>
      </div>
    </div>
  );
};
